"use strict";
module.exports = function SetIdentifier(value){
	this.value = value;
};
